module.exports = __webpack_public_path__ + "static/media/module.ab784234.svg";